<div class="wrapper-box wrapper-box-shadow table-wrapper p-p-1">
  <table mat-table class="basic-table plant-model-table" matSort [dataSource]="externalWorkData">

    <!-- Parameter Column -->
    <ng-container matColumnDef="parameter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">Parameter</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element.parameter}} </td>
    </ng-container>

    <!-- Target Column -->
    <ng-container matColumnDef="target">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">Target</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element.target}}</td>
    </ng-container>

    <!-- Actual Column -->
    <ng-container matColumnDef="actual">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">Actual</p>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field appearance="fill" class="field-fill-table" style="width: 40%;">
          <input matInput type="number" (change)="actualChange($event, element)" placeholder="Add Value"
            value="{{ element.actual }}" min="0" />
        </mat-form-field>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="externalWorkColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: externalWorkColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">{{langObj ? langObj?.nodatamatch : ('nodatamatch' | translate)}}</td>
    </tr>
  </table>
  <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
  </mat-paginator>
</div>